// load for root if VITE_V2 isnt 1

export function route(pageContext) {
  // return false if VITE_V2
  if (import.meta.env.VITE_V2 != "1") return false

  if(pageContext.urlPathname != '/') return false
  return { routeParams: {} }
}
